(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-popup"]) return;
  try {
    
{
  const popup = document.querySelector("[data-announcement-popup]");
  if (!popup) return;

  const DISMISS_KEY = "sveta_popup_dismissed";

  let dismissed = false;
  try { dismissed = sessionStorage.getItem(DISMISS_KEY) === "1"; } catch (e) {}
  if (dismissed) return;

  const endRaw = popup.dataset.end;
  const endDate = endRaw ? new Date(endRaw) : null;
  const hasValidEnd = endDate instanceof Date && !isNaN(endDate.getTime());
  if (endRaw && hasValidEnd && endDate.getTime() <= Date.now()) return;

  function dismiss() {
    popup.classList.remove("is-visible");
    setTimeout(() => { popup.hidden = true; }, 350);
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch (e) {}
  }

  popup.querySelectorAll("[data-popup-dismiss]").forEach((el) => {
    el.addEventListener("click", dismiss);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.classList.contains("is-visible")) dismiss();
  });

  const copyBtn = popup.querySelector("[data-popup-copy]");
  if (copyBtn) {
    copyBtn.addEventListener("click", () => {
      const code = copyBtn.dataset.code;
      const textEl = copyBtn.querySelector("[data-popup-copy-text]");
      const original = textEl.textContent;
      const restore = () => { textEl.textContent = original; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          textEl.textContent = "Copied!";
          setTimeout(restore, 1500);
        }).catch(() => {});
      }
    });
  }

  if (hasValidEnd) {
    const timerEl = popup.querySelector("[data-popup-timer]");
    const hrsEl = popup.querySelector("[data-timer-hrs]");
    const minsEl = popup.querySelector("[data-timer-mins]");
    const secsEl = popup.querySelector("[data-timer-secs]");
    const pad = (n) => String(n).padStart(2, "0");
    let intervalId;

    function tick() {
      const remaining = endDate.getTime() - Date.now();
      if (remaining <= 0) {
        hrsEl.textContent = "00";
        minsEl.textContent = "00";
        secsEl.textContent = "00";
        clearInterval(intervalId);
        return;
      }
      const totalSecs = Math.floor(remaining / 1000);
      hrsEl.textContent = pad(Math.floor(totalSecs / 3600));
      minsEl.textContent = pad(Math.floor((totalSecs % 3600) / 60));
      secsEl.textContent = pad(totalSecs % 60);
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  const delay = parseInt(popup.dataset.delay, 10) || 0;
  setTimeout(() => {
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add("is-visible"));
  }, delay);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  {
    const accordions = document.querySelectorAll('.footer-accordion[data-desktop-open]');
    // Start as null (not a real desktop/mobile value) so the initial sync call
    // below always runs instead of being skipped by the "no real change" guard.
    let footerIsDesktop = null;
    function handleFooterAccordions() {
      const isDesktop = window.innerWidth > 768;
      // Mobile browsers fire "resize" on scroll (address bar show/hide) even
      // when no breakpoint was actually crossed. Only react on a real change,
      // otherwise this would reset/interrupt an accordion mid-animation.
      if (isDesktop === footerIsDesktop) return;
      footerIsDesktop = isDesktop;
      accordions.forEach(details => {
        if (isDesktop) {
          details.setAttribute('open', '');
          details.classList.add('is-expanded');
          details.querySelector('summary').style.pointerEvents = 'none';
        } else {
          details.removeAttribute('open');
          details.classList.remove('is-expanded');
          details.querySelector('summary').style.pointerEvents = 'auto';
        }
      });
    }
    window.addEventListener('resize', handleFooterAccordions);
    handleFooterAccordions();

    // Open/close is driven entirely by CSS (grid-template-rows 0fr <-> 1fr),
    // which the compositor animates smoothly without the reflow-per-frame
    // jank that a JS-measured max-height transition causes. The native
    // `open` attribute is kept purely so the browser doesn't hide content
    // with display:none; it's only removed after the close transition ends,
    // and `.is-expanded` (not `[open]`) is what actually drives the CSS.
    function animateAccordion(details, opening) {
      const content = details.querySelector('.footer-col-content');
      if (opening) {
        details.setAttribute('open', '');
        details.classList.add('is-expanded');
      } else {
        details.classList.remove('is-expanded');
        if (!content) { details.removeAttribute('open'); return; }
        const onEnd = (e) => {
          if (e.propertyName !== 'grid-template-rows') return;
          content.removeEventListener('transitionend', onEnd);
          details.removeAttribute('open');
        };
        content.addEventListener('transitionend', onEnd);
      }
    }

    // Exclusive accordion on mobile (only one open at a time)
    accordions.forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => {
        const isDesktop = window.innerWidth > 768;
        if (isDesktop) return;
        e.preventDefault();

        const isOpen = details.classList.contains('is-expanded');
        if (isOpen) {
          animateAccordion(details, false);
          return;
        }

        accordions.forEach(otherDetails => {
          if (otherDetails !== details && otherDetails.classList.contains('is-expanded')) {
            animateAccordion(otherDetails, false);
          }
        });
        animateAccordion(details, true);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  const trigger = document.getElementById("searchTrigger");
  const overlay = document.getElementById("searchOverlay");
  const close = document.getElementById("searchClose");
  const input = document.getElementById("searchInput");
  const results = document.getElementById("searchResults");

  if (trigger && overlay && close) {
    trigger.addEventListener("click", () => {
      overlay.style.display = "block";
      document.body.style.overflow = "hidden";
      setTimeout(() => input.focus(), 60);
    });

    close.addEventListener("click", () => {
      overlay.style.display = "none";
      document.body.style.overflow = "";
      input.value = "";
      results.innerHTML = "";
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlay.style.display === "block") {
        close.click();
      }
    });

    input.addEventListener("input", (e) => {
      const q = e.target.value.trim().toLowerCase();
      if (!q) {
        results.innerHTML = "";
        return;
      }
      if (!window.SVETA) return;
      const items = SVETA.catalog.filter(p => p.name.toLowerCase().includes(q) || p.cat.toLowerCase().includes(q));

      results.innerHTML = items.map((p) => {
        const href = p.product_id ? ("/products/" + p.handle) : ("/?product=" + p.id);
        const imgSrc = (window.SVETA_ASSETS && window.SVETA_ASSETS[p.img]) ? window.SVETA_ASSETS[p.img] : (p.img_url || "");
        return `
        <a class="pcard" href="${href}" style="display:block; text-decoration:none;">
          <div class="site-header__search-result-media">
            <img src="${imgSrc}" alt="${p.name}">
          </div>
          <div class="pcard-info">
            <div class="site-header__search-result-name">${p.name}</div>
            <div class="site-header__search-result-price">${p.poa ? 'Enquire' : SVETA.fmt(SVETA.priceOf(p))}</div>
          </div>
        </a>
      `;
      }).join("");
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function(){
  function syncWishlistButtons() {
    if (!window.SVETA) return;
    document.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
      btn.classList.toggle("is-active", SVETA.inWishlist(btn.dataset.wishlistId));
    });
  }
  document.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!window.SVETA) return;
      SVETA.toggleWishlist(btn.dataset.wishlistId);
      syncWishlistButtons();
    });
  });
  syncWishlistButtons();
})();

(function(){
  const wrap = document.getElementById("scSort");
  const btn = document.getElementById("scSortBtn");
  if (!wrap || !btn) return;

  function close(){
    wrap.setAttribute("data-open", "false");
    btn.setAttribute("aria-expanded", "false");
  }
  function open(){
    wrap.setAttribute("data-open", "true");
    btn.setAttribute("aria-expanded", "true");
  }

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    wrap.getAttribute("data-open") === "true" ? close() : open();
  });
  document.addEventListener("click", (e) => {
    if (!wrap.contains(e.target)) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-index"]) return;
  try {
    
{
  /* Prev / Next + scroll progress bar */
  const grid = document.getElementById("featuredGrid");
  const prevBtn = document.getElementById("featPrev");
  const nextBtn = document.getElementById("featNext");
  const progressBar = document.getElementById("featuredProgress");

  function updateFeaturedState() {
    if (!grid) return;
    const maxScroll = grid.scrollWidth - grid.clientWidth;
    const atStart = grid.scrollLeft <= 2;
    const atEnd = maxScroll <= 2 || grid.scrollLeft >= maxScroll - 2;
    if (prevBtn) prevBtn.classList.toggle("is-disabled", atStart);
    if (nextBtn) nextBtn.classList.toggle("is-disabled", atEnd);
    if (progressBar) {
      const ratio = Math.min(grid.clientWidth / grid.scrollWidth, 1);
      const scrolled = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
      progressBar.style.width = (ratio * 100) + "%";
      progressBar.style.left = (scrolled * (100 - ratio * 100)) + "%";
    }
  }

  if (prevBtn && nextBtn && grid) {
    nextBtn.addEventListener("click", () => grid.scrollBy({ left:  grid.offsetWidth * 0.52, behavior: "smooth" }));
    prevBtn.addEventListener("click", () => grid.scrollBy({ left: -grid.offsetWidth * 0.52, behavior: "smooth" }));
    grid.addEventListener("scroll", updateFeaturedState, { passive: true });
    window.addEventListener("resize", updateFeaturedState);
    updateFeaturedState();
  }

  /* Featured product wishlist toggle */
  function syncFeaturedWishlist() {
    if (!window.SVETA) return;
    document.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
      const id = btn.dataset.wishlistId;
      btn.classList.toggle("is-active", SVETA.inWishlist(id));
    });
  }
  document.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!window.SVETA) return;
      SVETA.toggleWishlist(btn.dataset.wishlistId);
      syncFeaturedWishlist();
    });
  });
  syncFeaturedWishlist();

  /* Culture background watermark: rotation + dash-draw smoothly scrubbed to scroll position via a lerped rAF loop, fade/scale in on reveal */
  const cultureCopy = document.querySelector(".fn-culture__copy");
  if (cultureCopy) {
    const dashRange = 240;
    let targetRotate = 12, currentRotate = 12;
    let targetDash = 0, currentDash = 0;
    let targetScale = 0.85, currentScale = 0.85;

    function computeCultureTargets() {
      const rect = cultureCopy.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const progress = Math.min(Math.max((vh - rect.top) / (vh + rect.height), 0), 1);
      targetRotate = 12 + progress * 24;
      targetDash = progress * dashRange;
    }
    window.addEventListener("scroll", computeCultureTargets, { passive: true });
    window.addEventListener("resize", computeCultureTargets);
    computeCultureTargets();

    function tickCulture() {
      currentRotate += (targetRotate - currentRotate) * 0.08;
      currentDash += (targetDash - currentDash) * 0.08;
      currentScale += (targetScale - currentScale) * 0.08;
      cultureCopy.style.setProperty("--culture-bg-rotate", currentRotate + "deg");
      cultureCopy.style.setProperty("--culture-bg-dash", currentDash + "px");
      cultureCopy.style.setProperty("--culture-bg-scale", currentScale);
      window.requestAnimationFrame(tickCulture);
    }
    window.requestAnimationFrame(tickCulture);

    if ("IntersectionObserver" in window) {
      const cultureObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            cultureCopy.classList.add("is-visible");
            targetScale = 1;
            cultureObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      cultureObserver.observe(cultureCopy);
    } else {
      cultureCopy.classList.add("is-visible");
      targetScale = 1;
    }
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["not-found-fallback"]) return;
  try {
    
{
  function run() {
  const host = document.getElementById("sveta-not-found-fallback");
  const path = location.pathname.replace(/\/$/, "");
  const handle = path.split("/").filter(Boolean).pop() || "";
  const queryId = new URLSearchParams(location.search).get("id");
  const id = queryId || (/^sv-[a-z0-9]+$/i.test(handle) ? handle.toLowerCase() : "");

  const isCollection = path.startsWith("/collections/");
  if (isCollection) {
    let prods = window.SVETA ? SVETA.catalog : [];
    if (handle !== "all" && handle !== "new-in") {
      prods = prods.filter(p => p.cat.toLowerCase() === handle.toLowerCase());
    } else if (handle === "new-in") {
      prods = prods.slice(0, 8);
    }
    const title = handle.replace(/-/g, " ").toUpperCase();
    document.title = title + " - SVETA ATELIER";
    host.innerHTML = `
      <section class="section section--paper">
        <div class="wrap nf-wrap-pad">
          <h1 class="h-lg nf-title-serif">${title}</h1>
          <div class="grid grid-4" id="collection-grid"></div>
        </div>
      </section>
    `;
    document.getElementById("collection-grid").innerHTML = prods.map((r,n)=>`
      <a class="pcard" href="/?product=${r.id}" data-reveal data-delay="${n%4}">
              <div class="pcard-media nf-card-media">${(window.SVETA_ASSETS && window.SVETA_ASSETS[r.img]) ? `<img src="${window.SVETA_ASSETS[r.img]}" class="nf-fill-img">` : `<div class="ph ph--${r.tone} ar-port nf-card-ph"><span class="ph-mark">S</span></div>`}${r.tag ? `<span class="tag ${r.poa?'gold':''}">${r.tag}</span>` : ""}<div class="quick">View piece</div></div>
              <div class="pcard-info"><div><div class="p-name">${r.name}</div><div class="p-cat">${r.cat}</div></div><div class="p-price">${r.poa ? 'Enquire' : SVETA.fmt(SVETA.priceOf(r))}</div></div>
      </a>`).join("");
    if (window.SVETA && SVETA.reveal) SVETA.reveal();
    return;
  }

  if (id && window.SVETA && SVETA.byId(id)) {
    host.innerHTML = `
      <main class="pdp section--paper" id="pdp"></main>
      <section class="section section--paper2">
        <div class="wrap">
          <div class="between nf-related-head">
            <h2 class="h-md" data-reveal>Complete the look</h2>
            <a href="/collections/all" class="thread nf-link-small-caps" data-reveal>All pieces -></a>
          </div>
          <div class="grid grid-4" id="related"></div>
        </div>
      </section>`;

    const p = SVETA.byId(id);
    document.title = p.name + " - SVETA ATELIER";
    let size = "";
    const views = [p.tone, p.tone2 || p.tone, p.tone, "mist"];
    const hasImg = window.SVETA_ASSETS && window.SVETA_ASSETS[p.img];

    const thumbs = views.map((t,i)=>`<div class="ph ph--${t} ${i===0?'active':''}" data-v="${i}">${hasImg ? `<img src="${window.SVETA_ASSETS[p.img]}" class="nf-fill-img">` : '<span class="ph-mark">S</span>'}</div>`).join("");

    document.getElementById("pdp").innerHTML = `
      <div class="wrap">
        <div class="crumb"><a href="/">Maison</a> · <a href="/collections/all">Collection</a> · ${p.cat}</div>
        <div class="pdp-grid">
          <div class="gallery">
            <div class="thumbs">${thumbs}</div>
            <div class="main"><div class="ph ph--${p.tone}" id="mainImg">${hasImg ? `<img src="${window.SVETA_ASSETS[p.img]}" class="nf-fill-img">` : `<span class="ph-mark">S</span><span class="ph-cap">${p.name} - Plate I</span>`}</div></div>
          </div>
          <div class="pdp-info">
            <div class="pdp-cat">${p.cat} · ${p.made}</div>
            <h1 class="pdp-name">${p.name}</h1>
            <div class="pdp-price">${p.poa ? 'Price on request' : SVETA.fmt(SVETA.priceOf(p))}</div>
            <p class="pdp-blurb">${p.blurb}</p>
            ${p.poa ? `<span class="poa-tag">Made to order - by appointment</span>` : ""}
            <div class="size-head"><span class="lbl">${p.poa ? 'Fitting' : 'Select size'}</span><a href="#">Size &amp; fit guide</a></div>
            <div class="sizes" id="sizes">${p.sizes.map(s=>`<button data-s="${s}">${s}</button>`).join("")}</div>
            <p class="size-hint" id="sizeHint">Please select a size to continue.</p>

            <div class="customization nf-customization">
              <label class="nf-customization-label">Bespoke Customizations / Notes</label>
              <textarea id="customNotes" placeholder="Enter your custom measurements or requests..." class="nf-customization-textarea"></textarea>
            </div>

            <div class="pdp-actions nf-pdp-actions">
              <button class="btn nf-add-btn" id="addBtn">${p.poa ? 'Request appointment' : 'Add to cart'} <span class="arrow">-></span></button>
              <button class="btn nf-wishlist-toggle-btn" id="wishlistBtn">${window.SVETA && SVETA.inWishlist(p.id) ? '♥ Wishlisted' : '♡ Wishlist'}</button>
            </div>
          </div>
        </div>
      </div>`;

    const mainImg = document.getElementById("mainImg");
    document.querySelectorAll(".thumbs .ph").forEach(t=> t.addEventListener("click",()=>{
      document.querySelectorAll(".thumbs .ph").forEach(x=>x.classList.remove("active"));
      t.classList.add("active");
      mainImg.className = "ph ph--" + views[+t.dataset.v];
    }));
    document.querySelectorAll("#sizes button").forEach(b=> b.addEventListener("click",()=>{
      document.querySelectorAll("#sizes button").forEach(x=>x.classList.remove("active"));
      b.classList.add("active");
      size = b.dataset.s;
      document.getElementById("sizeHint").classList.remove("show");
    }));
    document.getElementById("addBtn").addEventListener("click",()=>{
      if (p.poa) { location.href = "/pages/contact"; return; }
      if (!size) { document.getElementById("sizeHint").classList.add("show"); return; }
      const custom = document.getElementById("customNotes").value;
      SVETA.add(p.id, size, 1, custom);
      document.getElementById("addBtn").innerHTML = "Added to cart ✓";
      setTimeout(() => document.getElementById("addBtn").innerHTML = "Add to cart ->", 2000);
    });

    document.getElementById("wishlistBtn").addEventListener("click",()=>{
      if (window.SVETA) {
        const added = SVETA.toggleWishlist(p.id);
        document.getElementById("wishlistBtn").innerHTML = added ? "♥ Wishlisted" : "♡ Wishlist";
      }
    });

    const rel = SVETA.catalog.filter(x=>x.id!==p.id).slice(0,4);
    document.getElementById("related").innerHTML = rel.map((r,n)=>`
      <a class="pcard" href="/?product=${r.id}" data-reveal data-delay="${n%4}">
        <div class="pcard-media nf-card-media">${(window.SVETA_ASSETS && window.SVETA_ASSETS[r.img]) ? `<img src="${window.SVETA_ASSETS[r.img]}" class="nf-fill-img">` : `<div class="ph ph--${r.tone} ar-port nf-card-ph"><span class="ph-mark">S</span></div>`}${r.tag ? `<span class="tag ${r.poa?'gold':''}">${r.tag}</span>` : ""}<div class="quick">View piece</div></div>
        <div class="pcard-info"><div><div class="p-name">${r.name}</div><div class="p-cat">${r.cat}</div></div><div class="p-price">${r.poa ? 'Enquire' : SVETA.fmt(SVETA.priceOf(r))}</div></div>
      </a>`).join("");
    if (SVETA.reveal) SVETA.reveal();
    return;
  }

  if (handle === "wishlist") {
    document.title = "Wishlist - SVETA ATELIER";
    const heartIcon = `<svg class="fn-pcard__wishlist-icon" fill="currentColor" viewBox="0 0 19 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.625 8.17901L9.5 16.7382L2.375 8.14373C1.52297 6.95173 1.1875 6.1465 1.1875 5.04417C1.1875 2.98836 2.64516 1.1382 4.75 1.12086C6.48137 1.10652 8.44431 2.88673 9.5 4.22878C10.5278 2.93395 12.5186 1.12086 14.25 1.12086C16.299 1.12086 17.8125 2.98836 17.8125 5.04417C17.8125 6.1465 17.5471 7.01152 16.625 8.17901ZM14.25 0C12.271 0 10.7736 1.16928 9.5 2.39117C8.28697 1.09456 6.72897 0 4.75 0C1.96294 0 0 2.41269 0 5.04417C0 6.45556 0.574157 7.47181 1.20294 8.42708L8.58503 17.3378C9.41331 18.2207 9.57006 18.2207 10.3983 17.3378L17.7971 8.42708C18.5369 7.47181 19 6.45556 19 5.04417C19 2.41269 17.0371 0 14.25 0Z"></path></svg>`;

    function renderWishlist() {
      const wItems = window.SVETA && SVETA.wishlist ? SVETA.wishlist() : [];
      const prods = wItems.map(id => SVETA.byId(id)).filter(Boolean);

      let content = "";
      if (prods.length === 0) {
        content = `
          <p class="nf-empty-note text-muted">You haven't added any pieces to your wishlist yet.</p>
          <a href="/collections/all" class="btn--paper btn mt-m">Explore the Collection</a>`;
      } else {
        content = `
          <div class="grid grid-4 nf-grid-spaced" id="wishlist-grid">
            ${prods.map((r,n)=>`
              <a class="fn-pcard" href="${r.handle ? '/products/' + r.handle : '/?product=' + r.id}" data-reveal data-delay="${n%4}">
                <div class="fn-pcard__media">${r.img_url ? `<img src="${r.img_url}" loading="lazy">` : (window.SVETA_ASSETS && window.SVETA_ASSETS[r.img]) ? `<img src="${window.SVETA_ASSETS[r.img]}" loading="lazy">` : `<div class="fn-pcard__fallback"><span class="fn-pcard__fallback-mark">S</span></div>`}</div>
                <div class="fn-pcard__info">
                  <div class="fn-pcard__text">
                    <div class="fn-pcard__name">${r.name}</div>
                    <div class="fn-pcard__price">${r.poa ? 'Enquire' : SVETA.fmt(SVETA.priceOf(r))}</div>
                  </div>
                  <button type="button" class="fn-pcard__wishlist is-active" data-wishlist-id="${r.id}" aria-label="Remove from wishlist">${heartIcon}</button>
                </div>
              </a>`).join("")}
          </div>`;
      }

      host.innerHTML = `
        <section class="section section--paper center nf-wishlist-section">
          <div class="wrap nf-full-width">
            <h1 class="h-lg mt-s nf-title-center-serif">Your Wishlist</h1>
            <div class="nf-text-center">${content}</div>
          </div>
        </section>`;

      host.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!window.SVETA) return;
          SVETA.toggleWishlist(btn.dataset.wishlistId);
          renderWishlist();
        });
      });
      if (window.SVETA && SVETA.reveal) SVETA.reveal();
    }

    renderWishlist();
    return;
  }

  host.innerHTML = `
    <section class="section section--paper center nf-404-section">
      <div class="wrap">
        <p class="eyebrow text-muted">404</p>
        <h1 class="h-lg mt-s">Page not found</h1>
        <a href="/" class="btn--paper btn mt-m">Back to SVETA Atelier</a>
      </div>
    </section>`;
  }

  // sveta.js (which defines window.SVETA) and this section's compiled script
  // are both deferred, but the compiled section bundle can execute first —
  // wait for window.SVETA so catalog-dependent rendering (wishlist, PDP-by-id,
  // collection grids) isn't silently skipped on first load.
  if (window.SVETA) {
    run();
  } else {
    let attempts = 0;
    const wait = setInterval(() => {
      attempts++;
      if (window.SVETA || attempts > 150) {
        clearInterval(wait);
        run();
      }
    }, 20);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  {
    const chips = document.getElementById("chips");
    const enquiringAbout = document.getElementById("enquiringAbout");
    if(chips && enquiringAbout){
      chips.addEventListener("click", e=>{ const b=e.target.closest("[data-chip]"); if(!b)return;
        chips.querySelectorAll("button").forEach(x=>x.classList.remove("active")); b.classList.add("active");
        enquiringAbout.value = b.dataset.chip; });
    }
    const form = document.getElementById("enquiry");
    const firstNameField = document.getElementById("contactFirstName");
    if(form && firstNameField){
      form.addEventListener("submit", e=>{
        const first = firstNameField.value.trim();
        const last = document.getElementById("contactLastName").value.trim();
        document.getElementById("contactFullName").value = [first, last].filter(Boolean).join(" ");
      });
    }
    // prefill and display order if arriving from cart/checkout
    if(form && firstNameField && /checkout/i.test(location.hash)){
      const m = form.querySelector('[name="contact[body]"]');
      try {
        const cartStr = localStorage.getItem("sveta-cart-v1");
        const cart = JSON.parse(cartStr);
        if(cart && cart.length > 0) {
          let textLines = ["I would like to place an order for the following items:\n"];
          let htmlLines = [];
          let total = 0;

          cart.forEach(item => {
             const p = (window.SVETA && window.SVETA.byId) ? window.SVETA.byId(item.id) : {name: item.id, price: 0};
             const linePrice = (window.SVETA && window.SVETA.getLinePrice) ? window.SVETA.getLinePrice(p, item.size) * item.qty : 0;
             total += linePrice;

             let itemTxt = `- ${item.qty}x ${p.name || item.id} (Size: ${item.size})`;
             if(item.custom) itemTxt += `\n  Bespoke: ${item.custom.replace(/\\n/g, ' ')}`;
             textLines.push(itemTxt);

             htmlLines.push(`
               <div class="checkout-line">
                 <div class="checkout-line-name">${item.qty}x ${p.name || item.id}</div>
                 <div class="checkout-line-size">Size: ${item.size}</div>
                 ${item.custom ? `<div class="checkout-line-bespoke">Bespoke: ${item.custom.replace(/\\n/g, ', ')}</div>` : ''}
               </div>
             `);
          });

          const fmtTotal = (window.SVETA && window.SVETA.fmt) ? window.SVETA.fmt(total) : total;
          if (m) m.value = textLines.join("\n") + `\n\nTotal Estimate: ${fmtTotal}\n\nPlease advise on payment and delivery.`;

          const summary = document.getElementById("checkoutSummary");
          const itemsDiv = document.getElementById("checkoutSummaryItems");
          if(summary && itemsDiv) {
            itemsDiv.innerHTML = htmlLines.join("") + `<div class="checkout-total">Total Estimate: ${fmtTotal}</div>`;
            summary.style.display = "block";
          }
        } else {
          if(m) m.value="I would like to arrange a bespoke fitting.";
        }
      } catch(e) {
        console.error("Error formatting cart for contact page:", e);
        if(m) m.value="I would like to complete my selection.";
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
{
  const root = document.getElementById("pdp");
  if (!root) return;
  const catalogId = root.dataset.catalogId;
  const dataEl = document.getElementById("pdVariantsData");
  let variants = [];
  try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch(e) { variants = []; }

  function fmtMoney(cents) {
    return window.SVETA ? SVETA.fmt(cents / 100) : ("₹" + (cents / 100).toLocaleString("en-IN"));
  }
  function findVariantByTitle(title) {
    return variants.find(v => v.title === title);
  }

  const sizesWrap = document.getElementById("pdSizes");
  const priceVal = document.getElementById("pdPriceVal");
  const addBtn = document.getElementById("pdAddBtn");
  const sizeHint = document.getElementById("pdSizeHint");
  let selectedVariant = null;

  if (sizesWrap) {
    sizesWrap.querySelectorAll("button").forEach(btn => {
      const v = findVariantByTitle(btn.dataset.value);
      if (v && !v.available) btn.classList.add("is-unavailable");
      btn.addEventListener("click", () => {
        sizesWrap.querySelectorAll("button").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        selectedVariant = v || null;
        if (sizeHint) sizeHint.classList.remove("show");
        if (selectedVariant && priceVal) priceVal.textContent = fmtMoney(selectedVariant.price);
        if (addBtn) {
          if (selectedVariant && !selectedVariant.available) {
            addBtn.textContent = "Sold out";
            addBtn.disabled = true;
          } else {
            addBtn.textContent = "Add to cart";
            addBtn.disabled = false;
          }
        }
      });
    });
  } else if (variants.length) {
    selectedVariant = variants[0];
  }

  if (addBtn) {
    addBtn.addEventListener("click", () => {
      if (sizesWrap && !selectedVariant) {
        if (sizeHint) sizeHint.classList.add("show");
        return;
      }
      const size = selectedVariant ? selectedVariant.title : "Default Title";
      if (window.SVETA) SVETA.add(catalogId, size, 1, "");
    });
  }

  const wishBtn = document.getElementById("pdWishlistBtn");
  function syncWishlist() {
    if (wishBtn && window.SVETA) {
      wishBtn.textContent = SVETA.inWishlist(catalogId) ? "♥ Wishlisted" : "Wishlist";
    }
  }
  if (wishBtn) {
    wishBtn.addEventListener("click", () => {
      if (window.SVETA) { SVETA.toggleWishlist(catalogId); syncWishlist(); }
    });
    syncWishlist();
  }

  /* Recommended section: wishlist heart on each card */
  function syncCardWishlistButtons() {
    if (!window.SVETA) return;
    document.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
      btn.classList.toggle("is-active", SVETA.inWishlist(btn.dataset.wishlistId));
    });
  }
  function bindWishlistButtons(container) {
    container.querySelectorAll(".fn-pcard__wishlist").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!window.SVETA) return;
        SVETA.toggleWishlist(btn.dataset.wishlistId);
        syncCardWishlistButtons();
      });
    });
  }
  bindWishlistButtons(document);
  syncCardWishlistButtons();

  /* Recommended section: swap the type-matched fallback for Shopify's native recommendations, once loaded */
  const recommendedGrid = document.getElementById("pdRecommendedGrid");
  const recommendedProgress = document.getElementById("pdRecommendedProgress");
  function updateRecommendedProgress() {
    if (!recommendedGrid || !recommendedProgress) return;
    const maxScroll = recommendedGrid.scrollWidth - recommendedGrid.clientWidth;
    const ratio = Math.min(recommendedGrid.clientWidth / recommendedGrid.scrollWidth, 1);
    const scrolled = maxScroll > 0 ? recommendedGrid.scrollLeft / maxScroll : 0;
    recommendedProgress.style.width = (ratio * 100) + "%";
    recommendedProgress.style.left = (scrolled * (100 - ratio * 100)) + "%";
  }
  if (recommendedGrid && recommendedProgress) {
    recommendedGrid.addEventListener("scroll", updateRecommendedProgress, { passive: true });
    window.addEventListener("resize", updateRecommendedProgress);
    updateRecommendedProgress();
  }
  if (recommendedGrid && recommendedGrid.dataset.recommendationsUrl) {
    fetch(recommendedGrid.dataset.recommendationsUrl)
      .then((r) => r.text())
      .then((html) => {
        const parsed = document.createElement("div");
        parsed.innerHTML = html;
        const cards = parsed.querySelectorAll(".sc-card");
        if (cards.length) {
          recommendedGrid.innerHTML = "";
          cards.forEach((card) => recommendedGrid.appendChild(card));
          bindWishlistButtons(recommendedGrid);
          syncCardWishlistButtons();
          updateRecommendedProgress();
        }
      })
      .catch(() => {});
  }

  /* Mobile gallery carousel: pagination dots */
  const gallery = document.getElementById("pdGallery");
  const dotsWrap = document.getElementById("pdGalleryDots");
  if (gallery && dotsWrap) {
    const dots = Array.from(dotsWrap.querySelectorAll(".pd-gallery__dot"));
    const slides = Array.from(gallery.children);

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const i = Number(dot.dataset.index);
        if (slides[i]) slides[i].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      });
    });

    let ticking = false;
    function syncActiveDot() {
      const galleryWidth = gallery.clientWidth || 1;
      const activeIndex = Math.round(gallery.scrollLeft / galleryWidth);
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === activeIndex));
      ticking = false;
    }
    gallery.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(syncActiveDot);
        ticking = true;
      }
    }, { passive: true });
  }

  /* Desktop magnifying-glass lens zoom */
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    const lensSize = 120;
    const zoomFactor = 2.5;
    document.querySelectorAll(".pd-gallery__item").forEach((item) => {
      const zoomSrc = item.dataset.zoomSrc;
      if (!zoomSrc) return;
      const lens = document.createElement("div");
      lens.className = "pd-zoom-lens";
      lens.style.backgroundImage = `url(${zoomSrc})`;
      item.appendChild(lens);

      item.addEventListener("mouseenter", () => lens.classList.add("is-active"));
      item.addEventListener("mouseleave", () => lens.classList.remove("is-active"));
      item.addEventListener("mousemove", (e) => {
        const rect = item.getBoundingClientRect();
        const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
        const y = Math.max(0, Math.min(e.clientY - rect.top, rect.height));
        lens.style.left = (x - lensSize / 2) + "px";
        lens.style.top = (y - lensSize / 2) + "px";
        lens.style.backgroundSize = (rect.width * zoomFactor) + "px " + (rect.height * zoomFactor) + "px";
        lens.style.backgroundPosition = -(x * zoomFactor - lensSize / 2) + "px " + -(y * zoomFactor - lensSize / 2) + "px";
      });
    });
  }

  const matToggle = document.getElementById("pdMaterialsToggle");
  const matBody = document.getElementById("pdMaterialsBody");
  if (matToggle && matBody) {
    matToggle.addEventListener("click", () => {
      const open = matBody.style.maxHeight && matBody.style.maxHeight !== "0px";
      matBody.style.maxHeight = open ? "0px" : matBody.scrollHeight + "px";
    });
  }

  document.querySelectorAll(".pd-drs-item").forEach(item => {
    const q = item.querySelector(".pd-drs-q");
    const a = item.querySelector(".pd-drs-a");
    if (!q || !a) return;
    q.addEventListener("click", () => {
      const open = item.classList.toggle("is-open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
